export { default } from './index.vue'



// WEBPACK FOOTER //
// ./packages/dof-circle-button/index.js